var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fillOpacity: 1,
    stroke: "#0569F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8751 10.5419C14.9691 9.44792 16.4528 8.83333 17.9999 8.83333C19.547 8.83333 21.0307 9.44792 22.1247 10.5419C23.2187 11.6358 23.8332 13.1196 23.8332 14.6667C23.8332 17.4605 24.4308 19.1955 24.9815 20.2051C25.258 20.712 25.5272 21.0446 25.7142 21.242C25.808 21.3409 25.8816 21.4065 25.926 21.4435C25.9482 21.462 25.963 21.4733 25.9694 21.4781L25.9718 21.4798C26.2706 21.685 26.4028 22.0604 26.2975 22.4082C26.1911 22.7596 25.8671 23 25.4999 23H10.4999C10.1327 23 9.80874 22.7596 9.70233 22.4082C9.59704 22.0604 9.72924 21.6851 10.028 21.4798L10.0304 21.4781C10.0368 21.4733 10.0517 21.462 10.0738 21.4435C10.1182 21.4065 10.1918 21.3409 10.2856 21.242C10.4726 21.0446 10.7418 20.712 11.0183 20.2051C11.569 19.1955 12.1666 17.4605 12.1666 14.6667C12.1666 13.1196 12.7812 11.6358 13.8751 10.5419ZM17.2791 25.0819C17.0482 24.6838 16.5382 24.5482 16.1401 24.7792C15.742 25.0101 15.6065 25.52 15.8374 25.9181C16.0572 26.297 16.3726 26.6115 16.7522 26.8301C17.1317 27.0487 17.562 27.1637 17.9999 27.1637C18.4379 27.1637 18.8682 27.0487 19.2477 26.8301C19.6272 26.6115 19.9427 26.297 20.1624 25.9181C20.3934 25.52 20.2579 25.0101 19.8597 24.7792C19.4616 24.5482 18.9517 24.6838 18.7208 25.0819C18.6475 25.2081 18.5424 25.313 18.4159 25.3858C18.2894 25.4587 18.1459 25.497 17.9999 25.497C17.8539 25.497 17.7105 25.4587 17.584 25.3858C17.4575 25.313 17.3524 25.2081 17.2791 25.0819Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.42d643d7e64beec2e108d0b8052dad26.svg";
export { ForwardRef as ReactComponent };